import editTipoNovedadForm from './editTipoNovedadFormModel';
const {
  formField: {
    // DATOS PARAMETROS 
    e_name,
    e_description,
    e_accion_1,
    e_resultado_1,
    e_cantidad_1,
    e_accion_2,
    e_resultado_2,
    e_cantidad_2,
    e_accion_3,
    e_resultado_3,
    e_cantidad_3,
    e_accion_4,
    e_resultado_4,
    e_cantidad_4
  } 
} = editTipoNovedadForm;

export default {
  [e_name.name]: '',
  [e_description.name]: '',
  [e_accion_1.name]: '',
  [e_resultado_1.name]: '',
  [e_cantidad_1.name]: '',
  [e_accion_2.name]: '',
  [e_resultado_2.name]: '',
  [e_cantidad_2.name]: '',
  [e_accion_3.name]: '',
  [e_resultado_3.name]: '',
  [e_cantidad_3.name]: '',
  [e_accion_4.name]: '',
  [e_resultado_4.name]: '',
  [e_cantidad_4.name]: ''
};

